// import { htmlEncode, toSingleByteNumber, isStatementInput, trimFirstEqualChar } from '../tags/js/common';
import { blocklyDispatcher } from './blocklyDispatcher';
import { IdentifyFactory } from '../utils/IdentifyFactory';
import { GlobalImport } from '../utils/GlobalImport';
import { BlockType } from '../@types/BlockType';
const Blockly = GlobalImport.getBlockly();
export type LibAtt = { libs: string; attr: string };

let useLibraryInWorkspace: LibAtt[] = [];
let staticHTMLList: string[] = [];
let assetsList: string[] = [];
let afterBodyJsList: string[] = [];

// ドキュメントの読み込みが終わった後でロード
window.addEventListener('load', () => {
  // ワークスペースが変更になったときに発生する
  // ID属性をすべて取得してリストにする。
  blocklyDispatcher.addSwitchWorkspaceListener(() => {
    AbstractBlock.initUseLibrary();
    AbstractBlock.initStaticHTML();
    AbstractBlock.initAssetsList();
  });
});

export abstract class AbstractBlock {
  constructor(name: string, title: string) {
    this.name = name;
    this.name_for_code = name;
    this.title = title;
  }

  name = '';
  name_for_code = '';
  title = '';
  tooltip = '';
  help_url = '';
  color = 0;
  attrBlock: any = null;
  nextBlock: any = null;
  nextStatement: any = null;
  propertyBlock: any = null;
  defaultValue = '';
  libs: LibAtt[] = [];
  field_value: any = null;
  in_statment: any = null;
  in_color: any = null;
  _hasLogic = false;
  _is_in_toolbox = true;
  _default_values: any[] = []; // { key: , value: };
  propertyValueBlock: any = null;

  ATTR = 'ATTR';
  IN = 'IN';

  static get useLibraryInWorkspace(): LibAtt[] {
    return useLibraryInWorkspace;
  }
  static get htmlList(): string {
    return staticHTMLList.join('');
  }

  static get assetsList(): string {
    return assetsList.join('');
  }

  static get javaScriptAfterBodyJsList(): string {
    return afterBodyJsList.join('');
  }

  hashedId(block: BlockType): string {
    return IdentifyFactory.instance.getHashId(block.id);
  }

  private static _hasLogic = false;
  static get hasLogic(): boolean {
    return this._hasLogic;
  }

  static set hasLogic(value: boolean) {
    this._hasLogic = value;
  }

  static initUseLibrary(): void {
    useLibraryInWorkspace = [];
  }

  static initStaticHTML(): void {
    staticHTMLList = [];
  }

  static initAssetsList(): void {
    assetsList = [];
  }

  static initAfterBodyJsList(): void {
    afterBodyJsList = [];
  }

  markUseLibrary(libs: LibAtt[]): void {
    for (const lib of libs) {
      // 入ってなければ
      if (
        !useLibraryInWorkspace.some((item: LibAtt) => {
          // console.log(item.lib, lib, typeof item.lib, typeof lib, item.lib == lib.lib);
          return item.libs == lib.libs;
        })
      ) {
        useLibraryInWorkspace.push(lib);
      }
    }
  }

  setStaticHTML(html: string): void {
    if (html && !staticHTMLList.includes(html)) {
      staticHTMLList.push(html);
    }
  }

  setAssetsList(assetHtml: string): void {
    if (assetHtml && !assetsList.includes(assetHtml)) {
      assetsList.push(assetHtml);
      assetsList = [...new Set(assetsList)];
    }
  }

  /**
   * Bodyの後に記述するべきJSコードを保持、コードの内容で重複除去する
   * @param code
   * @param block
   */
  setAfterBodyJavaScriptCodeList(code: string, block: BlockType): void {
    afterBodyJsList.push(code);
    afterBodyJsList = [...new Set(afterBodyJsList)];
  }

  setLibraryWithAtt(att: string, lib: string): AbstractBlock {
    if (lib !== '' && att !== '') {
      this.libs.push({ attr: att, libs: lib });
    }
    return this;
  }
  // ツールボックスでこのブaロックを使った時にどのライブラリを使うのかをセット
  setLibrary(name: string): AbstractBlock {
    if (name !== '') {
      this.libs.push({ attr: "type='text/javascript'", libs: name });
    }
    return this;
  }

  notify(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this; // BLOCKLYのinitはjson object式でありinit:function でこのAbstractを継承したクラスを参照したいため
    Blockly.Blocks[this.name] = {
      init: function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const block: BlockType = this;
        self.defineBlock(block);
      },
    };
    // this.blocklyblock = Blockly.Blocks[this.name];
    // バインド
    // console.log('selfname', this.name);
    Blockly.JavaScript[self.name] = this.toCode.bind(this);
  }

  // BlocklyAframeBuilderでworkspaceToCodeが呼ばれたら、プロジェクトに置かれたブロックについて、このtoCodeが呼ばれる
  toCode(block: BlockType): string[] | string {
    // ライブラリにマーク
    this.markUseLibrary(this.libs);

    // ルート要素がscene_startならスタティックなJSCODEを書き出す
    // ダイナミック操作のJSは、VirtualDOMで処理が回りきってしまうので、HTMLにトレースできない。JSに書きださなくてはならない。
    // SceneStartの直下のブロックだけで良い。
    const parent = block.getSurroundParent();

    // スタティックなHTML部分を取り出す
    this.setStaticHTML(this.generateStaticHTMLCode(block));
    this.setAssetsList(this.generateAssetsHTMLCode(block));

    // if (parent && parent.type === BlockTypeConsts.SCENE_START) {
    console.log('block', block.type);
    const afterBodyCode = this.generateAfterbodyJavaScriptCode(block);
    this.setAfterBodyJavaScriptCodeList(afterBodyCode, block);
    // }
    return this.codeGenerateCore(block);
  }

  toXmlFromSubBlock(dom): void {
    // 次のブロックはnext要素
    this.appendNextStatementBlock(this.nextStatement, dom);
    this.appendSubBlock('NEXT', this.nextBlock, dom);
    this.appendSubBlock('ATTR', this.attrBlock, dom);
    this.appendSubBlock('PROP', this.propertyBlock, dom);
    this.appendSubBlock('VALUE', this.propertyValueBlock, dom);
    this.appendSubBlock('IN', this.in_statment, dom);
    this.appendSubBlock('COLOR', this.in_color, dom);

    // deprecated
    this.appendFieldValueBlock(this.name, this.field_value, dom);

    for (const item of this._default_values) {
      // console.log('default ', item, item.key, item.value);
      this.appendFieldValueBlock(item.key, item.value, dom);
    }

    // 拡張ポイントを読み込み
    this.toXmlFromSubBlockCustom(dom);
  }

  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    //
  }

  appendNextStatementBlock(subBlock: AbstractBlock, dom: HTMLElement): void {
    if (subBlock != null) {
      const valueEl = document.createElement('next');
      valueEl.appendChild(subBlock.toXml());
      dom.appendChild(valueEl);
    }
  }

  appendSubBlock(name: string, subBlock: AbstractBlock, dom: HTMLElement): void {
    if (subBlock != null) {
      const valueEl = document.createElement('value');
      valueEl.setAttribute('name', name);
      valueEl.innerHTML = subBlock.toXml().outerHTML;
      dom.appendChild(valueEl);
    }
  }

  appendInStatementBlock(name: string, subBlock: AbstractBlock, dom: HTMLElement): void {
    if (subBlock != null) {
      const valueEl = document.createElement('statement');
      valueEl.setAttribute('name', this.IN);
      valueEl.innerHTML = subBlock.toXml().outerHTML;
      dom.appendChild(valueEl);
    }
  }

  appendFieldValueBlock(name: string, value: string, dom: HTMLElement): void {
    if (value != null) {
      const valueEl = document.createElement('field');
      valueEl.setAttribute('name', name);
      valueEl.innerHTML = value;
      dom.appendChild(valueEl);
    }
  }

  setNext(block: BlockType): AbstractBlock {
    // <value name="NEXT"></value>
    this.nextBlock = block;
    return this;
  }

  setNextStatement(block: BlockType): AbstractBlock {
    this.nextStatement = block;
    return this;
  }

  setAttribute(block: BlockType): AbstractBlock {
    // <value name="ATTR"></value>
    this.attrBlock = block;
    return this;
  }

  // エイリアス
  setAttr(block: BlockType): AbstractBlock {
    return this.setAttribute(block);
  }

  setProperty(block: BlockType): AbstractBlock {
    //<value name="value">
    this.propertyBlock = block;
    return this;
  }

  setPropertyValue(block: BlockType): AbstractBlock {
    this.propertyValueBlock = block;
    return this;
  }

  /**
   * ツールボックス用のXMLに変換する
   * @return {[type]}      [description]
   */
  toXml(): HTMLElement {
    if (this._is_in_toolbox) {
      const elem = document.createElement('block');
      elem.setAttribute('type', this.name);
      this.toXmlFromSubBlock(elem);
      return elem;
    } else {
      return null;
    }
  }

  defineBlock(block: BlockType): void {
    // override subclass
  }

  // HTMLコードでVRを作る場合に利用
  codeGenerateCore(block: BlockType): string[] | string {
    // override subclass
    return [];
  }

  /* オーバーライドする */
  generateAfterbodyJavaScriptCode(block: BlockType): string {
    return '';
  }

  /** シーンスタートのHTML部分に記載するHTMLを作る */
  generateStaticHTMLCode(block: BlockType): string {
    // override subclass
    return '';
  }

  /** シーンスタートのa-assets部分に記載するHTMLを作る */
  generateAssetsHTMLCode(block: BlockType): string {
    // override subclass
    return '';
  }

  /**
   * Optional Property setter
   */
  setColor(value: number): any {
    this.color = value;
    return this;
  }

  setNameForCode(value: string): any {
    this.name_for_code = value;
    return this;
  }

  setTooltip(value: string): any {
    this.tooltip = value;
    return this;
  }
  setHelpUrl(value: string): any {
    this.help_url = value;
    return this;
  }

  /**
   * Keyはフィールド名（defineで指定しているTextFieldなどの名前と合わせると勝手にブロックに入る。
   * getDefaultValueでは取れないので注意
   * @param {*} key
   * @param {*} value
   */
  addDefaultKeyValue(key: string, value: any): any {
    // console.log('addDefaultKeyValue', key, value);
    this._default_values.push({ key: key, value: value });
    return this;
  }

  /**
   * @deprecated use  addDefaultKeyValue
   */
  setFieldValue(value): any {
    // console.log('setFieldValue', value);
    this.field_value = value;
    return this;
  }

  setInStatement(value): any {
    this.in_statment = value;
    return this;
  }
  setIsInToolbox(value: boolean): any {
    this._is_in_toolbox = value;
    return this;
  }
  static clearGlobalStack(): void {
    useLibraryInWorkspace = [];
    staticHTMLList = [];
    assetsList = [];
    afterBodyJsList = [];
  }
}
